import React, { useState } from "react";
import PropTypes from "prop-types";
import { List, Pagination } from "antd";
import map from "lodash/map";
import remove from "lodash/remove";
import Toolbar from "../Toolbar";
import ListHeader from "../ListHeader";
import "./styles.css";
import ActionBar from "../ActionBar";

/**
 * @function
 * @name CustomList
 * @description List UI with tool bar , list header and list items
 */
const CustomList = ({
  datatestid,
  itemName,
  items,
  page,
  loading,
  itemCount,
  headerLayout,
  onPaginate,
  onRefresh,
  actionButtonProp,
  topSummary,
  generateExportUrl,
  renderListItem,
  paginationPosition = "top",
  showToolbar = true,
  backTo,
}) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectItem = (item) => {
    setSelectedItems([...selectedItems, item]);
  };

  const handleDeselectItem = (item) => {
    const selectedList = [...selectedItems];
    remove(selectedList, (listItem) => listItem._id === item._id);
    setSelectedItems(selectedList);
  };

  const isSelected = (item) => map(selectedItems, "_id").includes(item._id);

  return (
    <>
  <ActionBar actionButtonProp={actionButtonProp} showBackButton={!!backTo} backTo={backTo} />
      {topSummary && topSummary}
      <div className="List">
        {showToolbar && (
          <Toolbar
            itemName={itemName}
            page={page}
            total={itemCount}
            selectedItemsCount={selectedItems.length}
            onPaginate={onPaginate}
            onRefresh={onRefresh}
            exportUrl={
              generateExportUrl
                ? generateExportUrl({
                    filter: { _id: map(selectedItems, "_id") },
                  })
                : null
            }
            paginationPosition={paginationPosition}
          />
        )}
        <div className="List-container">
          <ListHeader headerLayout={headerLayout} />
          <div className="List-content">
            <List
              data-testid={datatestid}
              loading={loading}
              dataSource={items}
              renderItem={(item) =>
                renderListItem({
                  item,
                  isSelected: isSelected(item),
                  onSelectItem: () => handleSelectItem(item),
                  onDeselectItem: () => handleDeselectItem(item),
                })
              }
            />
          </div>
        </div>
        {paginationPosition === "bottom" && onPaginate && itemCount > 0 && (
          <div className="List-bottom-pagination">
            <Pagination
              simple
              current={page}
              defaultCurrent={page}
              total={itemCount}
              defaultPageSize={10}
              className="pagination"
              onChange={onPaginate}
              showSizeChanger={false}
              responsive
            />
          </div>
        )}
      </div>
    </>
  );
};

CustomList.propTypes = {
  loading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({ _id: PropTypes.string }))
    .isRequired,
  headerLayout: PropTypes.arrayOf(PropTypes.shape({ header: PropTypes.string }))
    .isRequired,
  itemName: PropTypes.string.isRequired,
  onPaginate: PropTypes.func,
  onRefresh: PropTypes.func,
  generateExportUrl: PropTypes.func,
  renderListItem: PropTypes.func.isRequired,
  datatestid: PropTypes.string,
  paginationPosition: PropTypes.string,
  showToolbar: PropTypes.bool,
  backTo: PropTypes.string,
};

CustomList.defaultProps = {
  generateExportUrl: null,
  onPaginate: null,
  datatestid: "",
  paginationPosition: "top",
  showToolbar: true,
  backTo: undefined,
};

export default CustomList;
